"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _preloadImage = _interopRequireDefault(require("FileManagerCore/utils/preloadImage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIIconCircle = _interopRequireDefault(require("UIComponents/icon/UIIconCircle"));

var _UIDropZone = _interopRequireDefault(require("UIComponents/drop/UIDropZone"));

var _IconConstants = require("UIComponents/icon/IconConstants");

var _UIFileButton = _interopRequireDefault(require("UIComponents/button/UIFileButton"));

var _UINanoProgressBar = _interopRequireDefault(require("FileManagerCore/components/UINanoProgressBar"));

var SIZES = ['small', 'large'];
var ICON_SIZES_FOR_DROP_SIZE = {
  small: 'xs',
  large: 'sm'
};
var IMAGE_NOT_FOUND_WIDTH = '60%';

var ImageUploadZone =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ImageUploadZone, _Component);

  function ImageUploadZone(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImageUploadZone);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImageUploadZone).call(this, props));
    _this.state = {
      hoveringOver: false,
      imageNotFoundError: false
    };
    _this.cancelPreloadImage = null;
    _this.handleUploadClick = _this.handleUploadClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleImageNotFound = _this.handleImageNotFound.bind((0, _assertThisInitialized2.default)(_this));
    _this.unsubscribePreloadImage = _this.unsubscribePreloadImage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ImageUploadZone, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkImageNotFoundError(this.props.imageUrl);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.imageUrl !== nextProps.imageUrl) {
        this.checkImageNotFoundError(nextProps.imageUrl);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribePreloadImage();
    }
  }, {
    key: "checkImageNotFoundError",
    value: function checkImageNotFoundError(imageUrl) {
      var _this2 = this;

      if (imageUrl) {
        this.unsubscribePreloadImage();
        this.cancelPreloadImage = (0, _preloadImage.default)(imageUrl, function () {
          return _this2.handleImageNotFound(false);
        }, function () {
          return _this2.handleImageNotFound(true);
        });
      } else {
        this.handleImageNotFound(false);
      }
    }
  }, {
    key: "handleImageNotFound",
    value: function handleImageNotFound(imageNotFoundError) {
      this.setState({
        imageNotFoundError: imageNotFoundError
      });
    }
  }, {
    key: "handleUploadClick",
    value: function handleUploadClick(event) {
      var onUpload = this.props.onUpload;
      onUpload(event.target.files);
    }
  }, {
    key: "unsubscribePreloadImage",
    value: function unsubscribePreloadImage() {
      if (this.cancelPreloadImage) {
        this.cancelPreloadImage();
        this.cancelPreloadImage = null;
      }
    }
  }, {
    key: "getIconSize",
    value: function getIconSize() {
      var _this$props = this.props,
          iconSize = _this$props.iconSize,
          size = _this$props.size;
      return iconSize || ICON_SIZES_FOR_DROP_SIZE[size];
    }
  }, {
    key: "getUse",
    value: function getUse() {
      var _this$props2 = this.props,
          isOver = _this$props2.isOver,
          error = _this$props2.error;
      if (isOver) return 'hover';
      if (error) return 'error';
      return 'default';
    }
  }, {
    key: "getIconName",
    value: function getIconName() {
      var _this$props3 = this.props,
          iconName = _this$props3.iconName,
          error = _this$props3.error;
      if (error) return 'warning';
      if (iconName) return iconName;
      return null;
    }
  }, {
    key: "renderUploadWithBrowse",
    value: function renderUploadWithBrowse() {
      var onBrowse = this.props.onBrowse;
      return _react.default.createElement("div", null, _react.default.createElement("div", null, this.renderUpload()), _react.default.createElement("div", {
        className: "m-top-2"
      }, _react.default.createElement(_UIButton.default, {
        use: "link",
        onClick: onBrowse
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.actions.browseImages"
      }))));
    }
  }, {
    key: "renderUpload",
    value: function renderUpload() {
      return _react.default.createElement("div", null, this.props.error, _react.default.createElement(_UIFileButton.default, {
        size: "small",
        accept: ['image/*'],
        onChange: this.handleUploadClick
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.actions.upload"
      })));
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this$props4 = this.props,
          showBrowse = _this$props4.showBrowse,
          children = _this$props4.children,
          error = _this$props4.error;

      if (children) {
        return _react.default.createElement("div", null, error, children);
      }

      if (showBrowse) {
        return this.renderUploadWithBrowse();
      }

      return this.renderUpload();
    }
  }, {
    key: "renderImageNotFound",
    value: function renderImageNotFound() {
      return _react.default.createElement("div", {
        className: "image-not-found"
      }, _react.default.createElement(_UIIllustration.default, {
        name: "empty-state-charts",
        className: "image-not-found-illustation",
        width: IMAGE_NOT_FOUND_WIDTH
      }), _react.default.createElement("p", {
        className: "text-center"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.errors.imageNotFound"
      })));
    }
  }, {
    key: "renderImage",
    value: function renderImage() {
      var _this$props5 = this.props,
          progress = _this$props5.progress,
          imageUrl = _this$props5.imageUrl,
          onRemove = _this$props5.onRemove;
      var imageNotFoundError = this.state.imageNotFoundError;
      return _react.default.createElement("div", {
        className: "image-upload-zone-image"
      }, progress === null && _react.default.createElement(_UIButton.default, {
        className: "image-upload-zone-remove-button",
        onClick: onRemove,
        use: "unstyled"
      }, _react.default.createElement(_UIIconCircle.default, {
        iconClassName: "image-upload-zone-close-button-icon",
        name: "cross2",
        backgroundColor: colors.PANTERA,
        borderColor: colors.PANTERA,
        color: colors.GYPSUM
      })), imageNotFoundError && progress === null ? this.renderImageNotFound() : _react.default.createElement(_UIImage.default, {
        src: imageUrl
      }), progress !== null && _react.default.createElement(_UINanoProgressBar.default, {
        color: colors.CALYPSO,
        value: progress
      }), progress !== null && _react.default.createElement("div", {
        className: "image-upload-zone__uploading-mask"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          imageUrl = _this$props6.imageUrl,
          size = _this$props6.size,
          onDragOver = _this$props6.onDragOver,
          onDrop = _this$props6.onDrop,
          onDragEnter = _this$props6.onDragEnter,
          onDragLeave = _this$props6.onDragLeave;
      return _react.default.createElement(_UIDropZone.default, {
        className: "image-upload-zone",
        iconName: this.getIconName(),
        iconSize: this.getIconSize(),
        use: this.getUse(),
        size: size,
        onDragOver: onDragOver,
        onDrop: onDrop,
        onDragEnter: onDragEnter,
        onDragLeave: onDragLeave
      }, imageUrl ? this.renderImage() : this.renderActions());
    }
  }]);
  return ImageUploadZone;
}(_react.Component);

exports.default = ImageUploadZone;
ImageUploadZone.propTypes = {
  children: _react.PropTypes.node,
  iconName: _react.PropTypes.string,
  iconSize: _react.PropTypes.oneOf(Object.keys(_IconConstants.ICON_SIZES)),
  imageUrl: _react.PropTypes.string,
  progress: _react.PropTypes.number,
  isOver: _react.PropTypes.bool.isRequired,
  showBrowse: _react.PropTypes.bool.isRequired,
  size: _react.PropTypes.oneOf(SIZES).isRequired,
  onUpload: _react.PropTypes.func.isRequired,
  onRemove: _react.PropTypes.func.isRequired,
  onBrowse: _react.PropTypes.func,
  onDragOver: _react.PropTypes.func,
  onDragEnter: _react.PropTypes.func,
  onDragLeave: _react.PropTypes.func,
  onDrop: _react.PropTypes.func,
  error: _react.PropTypes.node
};
ImageUploadZone.defaultProps = {
  showBrowse: false,
  iconName: null,
  size: 'large'
};
module.exports = exports.default;